export function sanitizeRichText(richText) {
    if (!richText) return null;
  
    const sanitizedContent = JSON.parse(JSON.stringify(richText));
    const walkNodes = (node) => {
      if (node.content) {
        node.content = node.content.map(walkNodes);
      }
  
      if (node.marks) {
        node.marks = node.marks.filter((mark) => mark.type !== "textStyle");
      }
  
      return node;
    };
  
    if (sanitizedContent.content) {
      sanitizedContent.content = sanitizedContent.content.map(walkNodes);
    }
  
    return sanitizedContent;
  }
  